import React, { Fragment } from 'react';

import Button from 'components/button';
import Modal from 'components/modal';
import style from './comment.module.scss';
import NoRecords from 'components/no-records';
import EditComments from './edit-comments';

import Trash from 'assets/icons/Trash.svg';
import editIcon from 'assets/images/greenEditIcon.svg';
import deleteIcon from 'assets/images/GreenDelIcon.svg';
import addIcon from 'assets/images/whiteAddIcon.svg';
import useHelper from './helper';
import moment from 'moment';
import Loader from 'components/loader';
import PermissionRestrict from 'hoc/PermissionRestrict';
import { ROLES } from 'permissions/constants';
import { A02_SCREEN_MESSAGES } from 'data/userFacingMessages';

const Comments = ({ setDisable }) => {
  const {
    toggle,
    comments,
    isLoading,
    edit,
    open,
    setToggle,
    setOpen,
    setEdit,
    handleDelete,
    onAdd,
    onEdit,
  } = useHelper();

  return (
    <div className={style.wraper}>
      {isLoading && <Loader />}
      {comments.length < 1 ? (
        !toggle && (
          <NoRecords
            noRecord={A02_SCREEN_MESSAGES.emptyPlaceholder.comments}
            icon={true}
            btnText={'Add Comment'}
            onClick={() => {
              setToggle(true);
              setDisable(true);
            }}
          />
        )
      ) : (
        <>
          <span className={style.comment}>Comments</span>
          <div className={style.scrollDiv}>
            <div className={style.innerScrollDiv}>
              {comments?.map((item, index) => {
                return (
                  <Fragment key={item._id}>
                    {index === edit ? (
                      <EditComments
                        data={item}
                        comments={comments}
                        index={index}
                        setToggle={setToggle}
                        setDisable={setDisable}
                        setEdit={setEdit}
                        onSubmit={onEdit}
                      />
                    ) : (
                      <div className={style.mainTab}>
                        <div style={{ width: '1500px' }}>
                          <div className={style.header}>
                            {' '}
                            <span className={style.dateSec}>
                              Last Updated on
                            </span>{' '}
                            <span
                              className={style.dateSec}
                              style={{ marginLeft: '5px' }}
                            >
                              {`    ${moment(item.commentDate).format(
                                'MM/DD/YY'
                              )}`}
                            </span>
                            <span
                              className={style.dateSec}
                              style={{ marginLeft: 5 }}
                            >
                              by {item.userName}
                            </span>
                          </div>
                          <div
                            style={{
                              paddingTop: '4px',
                              paddingRight: '32px',
                              overflowWrap: 'anywhere',
                            }}
                          >
                            <span
                              className={style.commentVal}
                              style={{
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {item.comment}
                            </span>
                          </div>
                        </div>
                        <div className={style.btnSection}>
                          <PermissionRestrict
                            roles={[ROLES.ADMIN, ROLES.EDITOR]}
                          >
                            <img
                              onClick={() => {
                                setEdit(index);
                                setDisable(true);
                                setToggle(false);
                              }}
                              src={editIcon}
                              width={25}
                              style={{ marginRight: '10px' }}
                            />
                            <img
                              src={deleteIcon}
                              onClick={() => setOpen(item._id)}
                              width={20}
                            />
                          </PermissionRestrict>
                        </div>
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </>
      )}
      {toggle && (
        <EditComments
          setDisable={setDisable}
          setEdit={setEdit}
          open={open}
          comments={comments}
          setToggle={setToggle}
          onSubmit={onAdd}
        />
      )}
      {comments?.length >= 1 && (
        <div style={{ margin: '24px 0px' }}>
          {!toggle && (
            <PermissionRestrict roles={[ROLES.ADMIN, ROLES.EDITOR]}>
              <Button
                text={'Add Comment'}
                btnClass={style.btnWraper}
                iconStart={addIcon}
                isLoading={isLoading}
                handleClick={() => {
                  setToggle(true);
                  setDisable(true);
                  setEdit(false);
                }}
              />
            </PermissionRestrict>
          )}
        </div>
      )}
      <Modal open={open} handleClose={() => setOpen(false)}>
        <div className={style.modalHeader}>
          <img src={Trash} height={48} width={48} />
          <h3 className={style.deleteText}>Delete Comment</h3>
          <p>Are you sure you want to delete this comment?</p>
          <Button
            btnClass={style.buttonStyle}
            text={A02_SCREEN_MESSAGES.popups.deleteConfirm.comment.yes}
            handleClick={handleDelete}
            isLoading={isLoading}
            width="100%"
          />
          <h3 className={style.cancelText} onClick={() => setOpen(false)}>
            {A02_SCREEN_MESSAGES.popups.deleteConfirm.comment.no}
          </h3>
        </div>
      </Modal>
    </div>
  );
};

export default Comments;
